import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import DocumentationStep from "./property-steps/documentation-step/DocumentationStep";
import MultimediaStep from "./property-steps/multimedia-step/MultimediaStep";
import DescriptionStep from "./property-steps/description-step/DescriptionStep";
import LocationStep from "./property-steps/location-step/LocationStep";
import BuildingStepForm from "./property-steps/buildings-step/BuildingStepForm";
import { useFormPropertySlice } from "../store/slices/FormPropertySlice";
import usePropertyHelpTypeLocations from "../hooks/helps/usePropertyHelpTypeLocations";
import { BuildingsProvider } from "./property-steps/buildings-step/context/Buildings-contexts/BuildingsContext";

interface IPropertyContainerFormProps {}
const PropertyContainerForm = (props: IPropertyContainerFormProps) => {
  const { currentStep } = useFormPropertySlice();
  const { isProject } = usePropertyHelpTypeLocations();

  return (
    <ContentLayout container id="form-layout">
      {currentStep == 0 && <LocationStep />}
      {currentStep == 1 && <DescriptionStep />}
      {currentStep == 3 && <MultimediaStep />}
      <BuildingsProvider>
        {currentStep == 2 && <DocumentationStep />}
        {currentStep == 4 && isProject && <BuildingStepForm />}
      </BuildingsProvider>
    </ContentLayout>
  );
};

export default PropertyContainerForm;

const headersHeight = 204;

const ContentLayout = styled(Grid)(({ theme }) => ({
  height: "100vh",
  maxHeight: `calc(100vh - ${headersHeight}px )`,
  overflow: "hidden",
  overflowY: "auto",
  padding: "1rem 1rem",
  paddingBottom: 20,
  display: "flex",
  flexDirection: "column"
}));
